/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TimeGrid/view.blocks to change it.
import * as fromData from 'Simple/Data'
import FullCalendarTimegrid from './FullCalendarTimegrid/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TimeGrid({
  children,
  viewPath = "/DesignSystem/TimeGrid"
  
}) {
let timegridResourcesValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'resources',
})
let timegridEventsValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'events',
})
let timegridDateValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'date',
})
let timegridSlotIntervalValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'slot_interval',
})
let timegridScrollTimeValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'scroll_time',
})
let timegridLocationValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'location',
})
let timegridSlotMinTimeValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'slot_min_time',
})
let timegridSlotMaxTimeValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'slot_max_time',
})
let timegridFocusedEventIdValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'focused_event_id',
})
let timegridSchedulingConfigValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'scheduling_config',
})
let timegridHipaaValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'hipaa',
})
  return (<React.Fragment
>
<FullCalendarTimegrid
  viewPath={`${viewPath}/FullCalendarTimegrid`}
 data="timegrid.resources"
 resources={timegridResourcesValueData}
 data="timegrid.events"
 events={timegridEventsValueData}
 data="timegrid.date"
 date={timegridDateValueData}
 data="timegrid.slot_interval"
 slotInterval={timegridSlotIntervalValueData}
 data="timegrid.scroll_time"
 scrollTime={timegridScrollTimeValueData}
 data="timegrid.location"
 location={timegridLocationValueData}
 data="timegrid.slot_min_time"
 slotMinTime={timegridSlotMinTimeValueData}
 data="timegrid.slot_max_time"
 slotMaxTime={timegridSlotMaxTimeValueData}
 data="timegrid.focused_event_id"
 focusedEventId={timegridFocusedEventIdValueData}
 data="timegrid.scheduling_config"
 schedulingConfig={timegridSchedulingConfigValueData}
 data="timegrid.hipaa"
 hipaa={timegridHipaaValueData}
/>
{children}
</React.Fragment>)
}